import React from "react";
import { Form, DatePicker } from "antd";
import "./AdnDatePicker.css";

function AdnDatePicker({
    name,
    label,
    rules,
    placeholder,
    disabledDate,
    disabledTime,
    disabled,
    onChange,
    defaultValue,
    defaultPickerValue,
    datePickerValue,
    format,
    className,
    allowClear = true,
    showTime = false,
}) {
    return (
        <Form.Item
            name={name}
            label={label}
            rules={rules}
        // className="adn-datepicker-size"
        >
            <DatePicker
                style={{ width: "100%" }}
                placeholder={placeholder}
                disabledDate={disabledDate}
                disabledTime={disabledTime}
                disabled={disabled}
                onChange={onChange}
                allowClear={allowClear}
                className={className}
                defaultValue={defaultValue}
                defaultPickerValue={defaultPickerValue}
                value={datePickerValue}
                format={format}
                showTime={showTime}
            />
        </Form.Item>
    );
}

export default AdnDatePicker;
